/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

const APPLICANT_URL = '/api/applicant/'
export const APPLICANT_SIMPLE_LIST_URL = '/api/applicant/simple/list/'

export function getApplicants(params) {
  const query = {
    ...params,
    meta: false,
  }

  return Request.getRequest(APPLICANT_SIMPLE_LIST_URL + '?' + qs.stringify(query))
    .then((result) => {
      return result.data.objects
    })
}

export function getApplicant(uid) {
  return Request.getRequest(APPLICANT_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export function postApplicant(data, uid) {
  return Request.postRequest(APPLICANT_URL + (uid ? uid + '/' : ''), data)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Applicant.js